export function defined<TValue>(value: TValue | null | undefined) {
  if (!value) {
    throw new Error("Value must be defined");
  }

  return value;
}
